/**
 * BulletList Component implemented with Material UI
 * 
 * This component uses MUI's List and ListItem components to render a bullet list
 * with customizable styling.
 */

import React from 'react';
import { List, ListItem, ListItemText, ListProps } from '@mui/material';
import { BulletListProps } from 'types/components/atoms';

/**
 * BulletList component
 * 
 * @param props - Component props
 * @returns A styled bullet list component
 */
const BulletList: React.FC<BulletListProps> = (props) => {
  const { content, ...rest } = props;
  
  return (
    <List
      sx={{
        background: '#fff',
        margin: 0,
        paddingLeft: 2, // Add some padding to match the default bullet list style
      }}
      {...rest as ListProps}
    >
      {content.map((item, index) => (
        <ListItem
          key={`line-${index}`}
          sx={{
            background: '#fff',
            color: 'var(--app-dark-gray)',
            padding: '0 16px',
            display: 'list-item', // This makes the list item display with a bullet
          }}
        >
          {typeof item === 'string' ? <ListItemText primary={item} /> : item}
        </ListItem>
      ))}
    </List>
  );
};

export type { BulletListProps };
export default BulletList;
